import { useQuery } from 'react-query';

import getScanSelfServiceProduct from '@/ebat/api/scan-self-service/getScanSelfServiceProduct';

const useScanSelfServiceProduct = (queryKey, disabled) =>
  useQuery(queryKey, getScanSelfServiceProduct, {
    enabled: !disabled,
    staleTime: 100,
  });

export default useScanSelfServiceProduct;
